import ContactBox from '~/themes/base/components/shop/ContactBox'

export default {
  extends: ContactBox,
}
